import '../css/Dashboardpage.css';
import DocumentRequest from '../model/request/Documentrequest';
import DocumentstatusResponse from '../model/response/DocumentstatusResponse';
// import Documentpath from '../model/response/Documentpath';
import { Oval } from "react-loader-spinner";
import Popup from './Popup';
import { useEffect, useState } from 'react';
import { useLocation } from "react-router-dom";


import { toast, ToastContainer } from 'react-toastify';
import ApiConfig from '../utils/ApiConfig';
import axios from 'axios';
import ApiResponse from '../model/response/ApiResponse';




function Numberpopup({ userData, onClose }) {
    const rawVal = localStorage.getItem('loginVal');
    let loginVal = rawVal ? JSON.parse(rawVal) : null;
    let token = loginVal ? loginVal.token : null;

    const [number, setNumber] = useState(userData?.mobileNumber);
    const [errors, setErrors] = useState({});
    // const [activeUser, setActiveUser] = useState([]);
    const [profile, SetProfile] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    // // const [documentstatus, setDocumentstatus] = useState(profile.documentStatus);
    // // const [type, setType] = useState(profile.type);

    function validate() {
        const newErrors = {};

        if (!number.trim()) {
            newErrors.number = 'Please enter your number';
        } else if (!/^[0-9]{10}$/.test(number)) {
            newErrors.number = 'Enter a valid 10-digit number';
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    }

    async function handleSubmit() {
        if (validate()) {
            number = await ApiConfig.encrypt(number);

        }
    }
    

    function showToast(message) {
        toast.success(message, {
            position: "top-right",
            autoClose: 2000
        });
    }
    function showToastFailed(message) {
        toast.error(message, {
            position: "top-right",
            autoClose: 2000
        });
    }

    useEffect(() => {
        setIsLoading(true);


    }, []);




    async function MobileVerified(isApproved) {

        if (!validate()) return;

        setIsLoading(true);

        var request = new DocumentRequest();

        request.userId = userData.user_Id;

        request.mobileNumber = await ApiConfig.encrypt(number);

        request.isApproved = isApproved;

        request.updatedBy = loginVal.user_Id;

        console.log("Request:", JSON.stringify(request));

        axios.put(
            ApiConfig.getUrl("User/mob_checkStatusType"),
            JSON.stringify(request),
            {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
            }
        )
            .then(response => {

                const api = ApiResponse.fromJson(response.data);

                if (api.statusCode == 200) {

                    showToast(api.response.message);
                    onClose();
                    setIsLoading(false);

                } else {

                    showToastFailed(api.message);
                }
            })
            .catch(error => {

                console.error(error);

                setIsLoading(false);

                showToastFailed("Update failed");
            });
    }

const disableRightClick = (e) => {
    e.preventDefault();
  };


    return (
        <div className='container mt-3' onContextMenu={disableRightClick}>
            {/* <input className='w-100 center decoration-none p-2' type='text'  placeholder='Enter Your Valid Number...'/> */}
            <input
                type="text"
                placeholder="Enter Mobile Number"
                className="form-control mt-3"
                value={number}
                onChange={(e) => setNumber(e.target.value)}
            />
            <span className="text-danger text-decoration-none">{errors.number}</span>

            <label className='mt-3'>If You Want To Verify Your Mobile Number Manually.</label><br />

            <div className='btn-group m-5' >
                <button
                    onClick={() => MobileVerified(true)}
                    style={{ backgroundColor: "green", color: "white", }}> Yes</button>
                <button
                    onClick={() => MobileVerified(false)}
                    style={{ backgroundColor: "red", color: "white", }}> No</button>
            </div>
        </div>
    );
}

export default Numberpopup;

//

// 